export enum ERolesCode {
  /**
   * @member {string}
   * @Type User type administrator
   * @description user super administrator. has all permissions
   */
  SUPER_ADMIN = "SUPER_ADMIN",
  /**
   * @member {string}
   * @Type User type administrator
   * @description user administrator. user administrator about his agency
   */
  ADMIN = "ADMIN",
  /**
   * @member {string}
   * @Type User type agent
   * @description user Broker. Account owner agency
   */
  BROKER = "BROKER",
  /**
   * @member {string}
   * @Type User type agent
   * @description  is  like user broker but have diferente name
   */
  BROKER_MANAGER = "BROKER_MANAGER",
  /**
   * @member {string}
   * @Type User type agent
   * @description user super senior.
   */
  SENIOR = "SENIOR",
  /**
   * @member {string}
   * @Type User type agent
   * @description user junior
   */
  JUNIOR = "JUNIOR",
  /**
   * @member {string}
   * @Type User type Client
   * @description i dont know what is this
   */
  CLIENT = "CLIENTE"
}

export const CRolesCode = {
  ...ERolesCode
};

export type TRolesCode = typeof ERolesCode;
